export const DEFAULT_HEADER_COLOR = '#F9F9F8';
export const FLIGHT_AND_HOTELS_COLOR = '#F9F9F8';
export const HOTELS_COLOR = '#F9F9F8';
export const EXPERIENCES_COLOR = '#F9F9F8';
export const AUTOS_COLOR = '#F9F9F8';

export const TRANSPARENT = '#00000000';
export const BLACK = '#000000';
export const WHITE = '#FFFFFF';
export const WHITE_1 = '#F9F9F8';
export const MODAL_BLUE_BACKGROUND = '#AAB8B8';
